module.exports = "<div>\n  {{errorMessage}}\n</div>"